const gsapController = async function (gsap) {
    const   mainMenu = document.querySelector('.main-menu'),
            numbers = document.querySelectorAll('.gsap-number') !== null,
            sectionImageWideAndHeading = document.querySelector('.image-wide--parallax') !== null,
            sectionImageHeading = document.querySelector('.image-and-heading') !== null,
            sectionHeadingWide = document.querySelector('.heading-wide__wrapper') !== null,
            heroParallax = document.querySelector('.hero-parallax') !== null,
            imagesParallax = document.querySelector('.image-parallax') !== null;

    if ( 
        mainMenu ||
        sectionHeadingWide ||
        imagesParallax
    ) {
        let gsap = await (await import('gsap')).default;
        
        if ( mainMenu ) {
            let AnimatedSection = await (await import('./gsap/main-menu')).default;
            AnimatedSection(gsap);
        }
        
        if (document.querySelector('.gsap-floors__floor')) {
            const maxRot = 10;
            const setRot = gsap.quickSetter(".gsap-floors__floor img", "x", "%");
    
            gsap.set(".gsap-floors__floor img", {transformOrigin: "center center"});
    
            let getPercent;
            function resize() {
                getPercent = gsap.utils.mapRange(0, innerWidth, -1, 1);
            }
    
            window.addEventListener("mousemove", e => {
                const percent = getPercent(e.pageX);
                setRot(percent * maxRot);
            });
    
            window.addEventListener("resize", resize);
            resize();
        }

        // Init ScrollTrigger
        if (
            numbers ||
            sectionImageWideAndHeading ||
            sectionImageHeading ||
            sectionHeadingWide ||
            imagesParallax
        ) {
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            gsap.registerPlugin(ScrollTrigger);

            if ( numbers ) {
                let AnimatedSection = await (await import('./gsap/numbers')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }

            if ( sectionImageWideAndHeading ) {
                let AnimatedSection = await (await import('./gsap/image-wide-and-heading')).default; 
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( sectionImageHeading ) {
                let AnimatedSection = await (await import('./gsap/image-and-heading')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( sectionHeadingWide ) {
                let AnimatedSection = await (await import('./gsap/heading-wide')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( imagesParallax ) {
                let AnimatedSection = await (await import('./gsap/images-parallax')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
            
            if ( heroParallax ) {
                let AnimatedSection = await (await import('./gsap/hero-parallax')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
        }
    }
};

export const init = gsapController;